module.exports = __webpack_public_path__ + "static/netnumber-5dfd6825fba3d6ddb02fdc39ff44008d.png";